// extracted by mini-css-extract-plugin
export default {"app_container":"main_app_container__ju1Su","error":"main_error__eM5bw"};